import { cn } from "@/shared/lib/cn";

type BadgeVariant = "success" | "warning" | "danger" | "info" | "purple" | "neutral";

/** Pastille arrondie : fond clair, contour fin et point de couleur (sauf « purple », réservé aux identifiants). */
const variants: Record<BadgeVariant, { badge: string; dot?: string }> = {
  success: {
    badge: "rounded-full bg-emerald-50 text-emerald-700 ring-emerald-200 dark:bg-emerald-500/10 dark:text-emerald-300 dark:ring-emerald-500/20",
    dot: "bg-emerald-500",
  },
  warning: {
    badge: "rounded-full bg-amber-50 text-amber-700 ring-amber-200 dark:bg-amber-500/10 dark:text-amber-300 dark:ring-amber-500/20",
    dot: "bg-amber-500",
  },
  danger: {
    badge: "rounded-full bg-red-50 text-red-700 ring-red-200 dark:bg-red-500/10 dark:text-red-300 dark:ring-red-500/20",
    dot: "bg-red-500",
  },
  info: {
    badge: "rounded-full bg-sky-50 text-sky-700 ring-sky-200 dark:bg-sky-500/10 dark:text-sky-300 dark:ring-sky-500/20",
    dot: "bg-sky-500",
  },
  purple: {
    badge: "rounded-md bg-violet-100 text-violet-700 ring-violet-200/70 tabular-nums dark:bg-violet-500/15 dark:text-violet-300 dark:ring-violet-500/20",
  },
  neutral: {
    badge: "rounded-full bg-card-muted text-muted-foreground ring-border",
    dot: "bg-slate-400",
  },
};

type StatusBadgeProps = {
  children: React.ReactNode;
  variant?: BadgeVariant;
  className?: string;
};

export function StatusBadge({ children, variant = "neutral", className }: StatusBadgeProps) {
  const style = variants[variant];

  return (
    <span
      className={cn(
        "inline-flex items-center gap-1.5 whitespace-nowrap px-2.5 py-1 text-xs font-semibold ring-1",
        style.badge,
        className,
      )}
    >
      {style.dot ? <span className={cn("h-1.5 w-1.5 shrink-0 rounded-full", style.dot)} aria-hidden="true" /> : null}
      {children}
    </span>
  );
}
